export default __webpack_public_path__ + "static/media/TT Norms Pro ExtraBlack.dffd12f9.otf";